export const IT_DETALLE_ESTADO_PENDIENTE_RECHAZO = 'PENDIENTE DE RECHAZO';
export const IT_DETALLE_PERMISO_MODIFICAR_CUMPLIMIENTO =
  'rsModificarCumplimiento';
export const IT_DETALLE_PERMISO_ANULAR_RECHAZO_OC = 'rsAnulaRechazoOC';
export const IT_DETALLE_ESTADO_FACTURA_CLIENTE = 'CLIENTE';

export const IT_DETALLE_RESUMEN_ORDEN = 'Detalle de la orientacion';
export const IT_DETALLE_BREADCRUMB_MODULO = 'Informacion de Tareas';

// Legacy: WidgetsNamesConstants.properties -> mensajeNoProgramacionesOrden
export const IT_DETALLE_MENSAJE_NO_PROGRAMACIONES =
  'No se encontró información de programaciones para la orientación';

// Legacy: WidgetsNamesConstants.properties -> busquedaActaGirop
export const IT_DETALLE_MENSAJE_BUSQUEDA_ACTA_GIROP =
  'No se encontró el cumplimiento asociado a un acta en gestión 360.';

export const IT_DETALLE_RESUMEN_ERROR = 'Error';
export const IT_DETALLE_RESUMEN_ADVERTENCIA = 'Advertencia';
export const IT_DETALLE_RESUMEN_INFORMACION_EMPRESA = 'Informacion Empresa';
export const IT_DETALLE_NAVIGATION_STATE_ID = 'nmconsecutivoOrden';
export const IT_DETALLE_NAVIGATION_STATE_QUERY_PARAMS_REGRESO =
  'queryParamsRegreso';

export const IT_DETALLE_TOOLTIP_ANULAR_RECHAZO_SIN_PERMISO =
  'No cuenta con permisos para anular rechazo.';
export const IT_DETALLE_TOOLTIP_MODIFICAR_HU3 = 'Modificar programación';
export const IT_DETALLE_TOOLTIP_DESCARGAR_ACTA = 'Descargar Acta 360';

// Legacy: DetalleOrdenViewImpl.java -> buildConfirmCustomDialog en modificar cumplimiento
export const IT_DETALLE_MENSAJE_CONFIRMAR_DETALLE_CALCULADO =
  'El cumplimiento se encuentra asignado a un detalle de servicios calculado. Se actualizará el estado a pendiente. ¿Desea continuar?';

export const IT_DETALLE_TEXTO_ANULAR_RECHAZO = 'Anular Rechazo';
export const IT_DETALLE_TEXTO_ESTADO_PENDIENTE_RECHAZO =
  'La orden esta en estado PENDIENTE DE RECHAZO.';
export const IT_DETALLE_ANULAR_RECHAZO_JUSTIFICACION_MIN = 1;
export const IT_DETALLE_ANULAR_RECHAZO_JUSTIFICACION_MAX = 500;
export const IT_DETALLE_ANULAR_RECHAZO_TITULO_MODAL =
  'Anular rechazo de orientacion';
export const IT_DETALLE_ANULAR_RECHAZO_RESUMEN_EXITO =
  'Anulacion de rechazo aplicada';
export const IT_DETALLE_ANULAR_RECHAZO_RESUMEN_ERROR =
  'No fue posible anular rechazo';
export const IT_DETALLE_ANULAR_RECHAZO_DETALLE_EXITO_DEFAULT =
  'La solicitud de rechazo fue anulada correctamente.';
export const IT_DETALLE_ANULAR_RECHAZO_DETALLE_ERROR_DEFAULT =
  'No fue posible anular la solicitud de rechazo.';

export const IT_DETALLE_COLSPAN_CON_MODIFICAR = 13;
export const IT_DETALLE_COLSPAN_SIN_MODIFICAR = 12;
